<div class="container">
  <div style="display: flex; flex-direction: column; align-items: start; width: 100%; gap: 10px;">
    @if (!lanIPsLoading && !errorLanIPs) {
      <div class="ip-sections-row">
        <div class="lan-data-container">
          <h2 class="container-header">LAN IPv4 Addresses</h2>
          <div class="ip-container">
            @for (ip of lanIPs; track $index) {
              <mat-card class="ip-card">
                <p>{{ ip }}</p>
              </mat-card>
            }
          </div>
        </div>

        <div class="lan-data-container">
          <h2 class="container-header">WAN IPv4 Addresses</h2>
          <div class="ip-container">
            @for (ip of wanIPs; track $index) {
              <mat-card class="ip-card">
                <p>{{ ip }}</p>
              </mat-card>
            }
          </div>
        </div>
      </div>
    } @else if (!lanIPsLoading && errorLanIPs) {
      <p>Error getting LAN addresses.</p>
    } @else {
      <div class="centered-content">
        <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
      </div>
    }
  </div>

  <div class="ports-container">
        @if(loading && !errorOnLoading){
        <div class="centered-content">
            <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
        </div>
        }

        @if (!loading && errorOnLoading) {
        <div class="error-container">
            <p>Unable To Load Ports For Device.</p>
        </div>
        }
        @if(!loading && !errorOnLoading){
        <div class="section-container">
            <div class="inner-container">
                <h2 class="container-header">Currently Active Ports</h2>
                <div class="ports">
                    @for (elem of ports; track $index) {
                    <mat-card (click)="selectedPort = elem" [ngClass]="{'selected-port': elem.id == selectedPort.id}">
                        <img [src]=getPortImage(elem) alt="{{elem.name + ' Port ' + elem.position}}" />
                    </mat-card>
                    }
                </div>
                @if(selectedPort && selectedPort.topology && selectedPort.topology.length > 0){
                <h2 class="container-header">
                    Topology for {{selectedPort.name === "LAN" ? selectedPort.name+" "+selectedPort.position:
                    selectedPort.name}}
                </h2>
                <div class="topologies">
                    @for(elem of selectedPort.topology; track $index){
                    <mat-card class="topology-card">
                        <div class="device-info">
                            <h3>{{elem.MAC}}</h3>
                        </div>
                        <div class="extra-device-info">
                            <p>Vendor: {{elem.Vendor!=""?elem.Vendor:"-"}}</p>
                            <p>VID: {{elem.VID}}</p>
                        </div>
                    </mat-card>
                    }

                </div>
                }
            </div>
        </div>
        <div class="section-container">
            <div class="inner-container">
                <h2 class="container-header">Connected Devices</h2>
                <div class="devices">
                    @for (elem of connectedDevices; track $index) {
                    <mat-card>
                        <div class="device-info">
                            <h3 style="margin-right: 10px;">{{elem.IP}}</h3>
                            <p>{{elem.MAC}}</p>
                        </div>
                        <div class="extra-device-info">
                            <p>Hostname: {{elem.Hostname != "" ? elem.Hostname : '-'}}</p>
                            <p>Interface: {{elem.Interface != "" ? elem.Interface : '-'}}</p>
                            <p>Type: {{elem.Type != "" ? elem.Type : '-'}}</p>
                            <p>Vendor: {{elem.Vendor != "" ? elem.Vendor : '-'}}</p>
                            <p>Current Port: {{elem.CurrentPort != "" ? elem.CurrentPort : "-"}}</p>
                        </div>
                    </mat-card>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</div>
